
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("28QMN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0df270f59a205adc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $0df270f59a205adc$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Abbrechen',
    'fabric.linkPicker.button.insert': "Einf\xfcgen",
    'fabric.linkPicker.button.save': 'Speichern',
    'fabric.linkPicker.clearLink': "L\xf6schen",
    'fabric.linkPicker.clearLinkText': "Text l\xf6schen",
    'fabric.linkPicker.hyperlink.searchLinkResults': "{count, plural, =0 {Keine Ergebnisse gefunden} one {{count,number}\xa0Ergebnis gefunden} other {{count,number}\xa0Ergebnisse gefunden}}",
    'fabric.linkPicker.linkAriaLabel': 'Geben Sie einen Link in das Feld ein oder kopieren Sie einen hinein',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Hilfstext zur Linkanzeige',
    'fabric.linkPicker.linkHelperTextLabel': 'Geben Sie diesem Link einen Titel oder eine Beschreibung',
    'fabric.linkPicker.linkInvalid': "Geben Sie eine g\xfcltige URL ein.",
    'fabric.linkPicker.linkLabel': "Verkn\xfcpfung",
    'fabric.linkPicker.linkPlaceholder': "Link einf\xfcgen",
    'fabric.linkPicker.linkTextAriaLabel': 'Anzeigetext des Links',
    'fabric.linkPicker.linkTextLabel': 'Anzeigetext (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text zum Anzeigen',
    'fabric.linkPicker.listTitle.recentlyViewed': "K\xfcrzlich angesehen",
    'fabric.linkPicker.listTitle.results': 'Ergebnisse',
    'fabric.linkPicker.noEmbed': "Die eingebettete Ansicht wird f\xfcr diesen Link nicht unterst\xfctzt. <a>Weitere Informationen dazu, warum manche intelligente Links keinen Inhalt anzeigen</a>",
    'fabric.linkPicker.search.error.description': 'Laden Sie die Seite erneut oder wenden Sie sich an den <a>Atlassian Support</a>, falls das Problem weiterhin besteht.',
    'fabric.linkPicker.search.error.heading': 'Beim Laden dieser Daten ist ein Problem aufgetreten.',
    'fabric.linkPicker.search.error.retry': 'Neu laden',
    'fabric.linkPicker.search.linkAriaLabel': "W\xe4hrend Ihrer Eingabe in das Feld werden unten Vorschl\xe4ge angezeigt",
    'fabric.linkPicker.search.linkLabel': "Link suchen oder einf\xfcgen",
    'fabric.linkPicker.search.linkPlaceholder': "Aktuelle Links finden oder neuen Link einf\xfcgen",
    'fabric.linkPicker.search.noResults.description': 'Versuchen Sie es mit einem anderen Begriff erneut.',
    'fabric.linkPicker.search.noResults.heading': "Es wurden keine passenden Ergebnisse gefunden, die mit Ihrem Suchbegriff \xfcbereinstimmen.",
    'fabric.linkPicker.status.submitting': 'Wird gesendet',
    'fabric.linkPicker.time.message.updated': 'Aktualisiert: {time}',
    'fabric.linkPicker.time.message.viewed': 'Angesehen: {time}',
    'fabric.linkPicker.unhandledError.description': 'Versuchen Sie, die Seite neu zu laden.',
    'fabric.linkPicker.unhandledError.heading': 'Etwas ist schiefgelaufen!'
};

});


//# sourceMappingURL=de.70720d4d.js.map
